import React, { useEffect, useState } from "react";


import Card from "../cards/Card";
import { Navigation, Pagination, A11y, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft, faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";

const Feedback = () => {
  const [data,setData]= useState([])
  useEffect(()=>{
    const fetchData = async () => {
      try {
        const response = await axios.get('https://sychoclinicapi.runasp.net/api/feedbacks');
        setData(response.data);
        console.log(response.data)
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    fetchData()
    console.log('test')
    // console.log(data)
  },[])

  
    const showData = data&& data.map((e)=>{
      return(
        <SwiperSlide key={e.id} style={{minWidth:"200px !important",maxWidth:"325px !important"}} >
        <Card name={e.name} feedback={e.feedback} date={e.date} />
      </SwiperSlide>
      )
    })


  

  return (
    <div
      id="FeedBack"
      className="d-flex bgHome border-none  shadow justify-content-center align-items-center flex-column py-5 "
    >
      <h2 className=" fw-bold fs-1 pb-2 mb-4 text-center m-auto fw-bold after position-relative">
        Feedback
      </h2>
      <div className="container">
      
          {/* vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv */}
        
          <div style={{ position: "relative", width: "100%" }}>
        <div
          className="swiper-button-next"
          style={{
            position: "absolute",
            top: "50%",
            right: "10px",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            padding: "8px",
            textAlign: "center",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            backgroundColor: "#25e",
            alignItems: "center",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          <FontAwesomeIcon icon={faAngleDoubleRight} />
        </div>
        <div
          className="swiper-button-prev"
          style={{
            position: "absolute",
            top: "50%",
            left: "10px",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            padding: "8px",
            textAlign: "center",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            backgroundColor: "#25e",
            alignItems: "center",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          <FontAwesomeIcon icon={faAngleDoubleLeft} />
        </div>
        <Swiper
          style={{
            width: "100%",
            padding: "5px 30px",
            borderRadius: "37px",
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          autoplay={{
            delay: 3000,
            // disableOnInteraction: false,
          }}
          speed={1000}
          modules={[Autoplay, Navigation, Pagination, A11y]}
          spaceBetween={30}
          // pagination={{ clickable: true }}
          // onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={() => console.log("slide change")}
          breakpoints={{
            992: {
              slidesPerView: 3,
            },
            779: {
              slidesPerView: 2,
            },
            0: {
              slidesPerView: 1,
            },
          }}
          pagination
        >
      {showData}
        </Swiper>
      </div>

{/* ررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررررر */}

      </div>
    </div>
  );
};

export default Feedback;
